import isPropValid from '@emotion/is-prop-valid';
import {css} from '@emotion/react';
import styled from '@emotion/styled';
import {Block} from '@travel-frontend/ui-components';

export type Props = {
  orientation?: 'horizontal' | 'vertical';
  category?: 'primary' | 'secondary';
  variant?: 'solid' | 'dotted';
};

export const Divider = styled(Block, {
  shouldForwardProp: (property) =>
    isPropValid(property) && property !== 'orientation',
})<Props>(
  ({
    theme,
    orientation = 'horizontal',
    category = 'secondary',
    variant = 'solid',
  }) => css`
    ${orientation === 'horizontal' &&
    css`
      border-top: 1px ${variant};
    `}

    ${orientation === 'vertical' &&
    css`
      border-left: 1px ${variant};
    `}

    border-color: ${{
      primary: theme.colors.borderPrimary,
      secondary: theme.colors.borderSecondary,
    }[category]};
  `
);
